export default "__VITE_ASSET__DmDuR5Wk__"